(() => {
  function activateTab(section, selectedTab) {
    const tabs = Array.from(section.querySelectorAll('[data-insights-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-insights-panel]'));
    const selectedName = selectedTab.dataset.insightsTab;

    tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.insightsPanel !== selectedName;
    });
  }

  function setupSection(section) {
    if (section.dataset.productInsightsReady === 'true') return;
    section.dataset.productInsightsReady = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-insights-tab]'));
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(section, tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        tabs[nextIndex].focus();
        activateTab(section, tabs[nextIndex]);
      });
    });

    const sizeSelect = section.querySelector('[data-insights-size-select]');
    const sizePanels = Array.from(section.querySelectorAll('[data-insights-size-panel]'));
    sizeSelect?.addEventListener('change', () => {
      sizePanels.forEach((panel) => {
        panel.hidden = panel.dataset.insightsSizePanel !== sizeSelect.value;
      });
    });
  }

  function setupAllSections() {
    document.querySelectorAll('[data-product-insights]').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAllSections, { once: true });
  } else {
    setupAllSections();
  }

  document.addEventListener('shopify:section:load', setupAllSections);
})();
